import apiClient from "@/api/client";
import type { DirectorApprovalsResponse } from "../types";

export const directorApprovalsApi = {
  /** `allFees` — także opłaty, które może zaakceptować koordynator (do progu kwotowego). */
  list: (allFees: boolean) =>
    apiClient
      .get<DirectorApprovalsResponse>("/director-approvals/", {
        params: allFees ? { all_fees: 1 } : undefined,
      })
      .then((r) => r.data),
};
